import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'common/components/elements/icons';
import Loader from 'common/components/elements/loader/circle';
import classNames from 'classnames';

const SwitchItem = ({
   checked,
   onClick,
   icon,
   label,
   isLoading,
   iconSize,
   newstyle,
}) => {
   return (
      <div
         className={ classNames({
            'flex flex-col justify-center items-center cursor-pointer relative flex-1': true,
            'bg-grey-main': !newstyle,
            'w-full !overflow-hidden !rounded-lg !px-[14px] !py-[10px]': newstyle,
            'bg-panel': newstyle && checked,
            'bg-transparent': newstyle && !checked,
         }) }
         style={ newstyle && checked ? {
            boxShadow: '0px 1px 3px 0px #1018281A',
         } : {} }
         role='presentation'
         onClick={ onClick }
      >
         <div
            className={ cx({
               'w-full h-full rounded-lg flex flex-col justify-center items-center cursor-pointer relative flex-1': true,
               'bg-panel text-action dark:bg-panel-dark dark:text-action': checked,
               'bg-grey-main dark:bg-black-field': !checked,
               '!bg-transparent': !checked && newstyle,
               'sm:!flex-row items-center justify-center !gap-2 !overflow-hidden !rounded-lg !w-fit': newstyle,
            }) }
         >
            {
               (!isLoading || checked) && (
                  <>
                     {/* TODO icon component, temporary solution */}
                     { !!icon && (
                        <div className={ `flex items-center justify-center mb-2 ${ newstyle ? '!mb-0' : 'h-7 w-7' }` }>
                           <Icon
                              size={ icon === 'unpublish' && newstyle ? 'xl' : iconSize }
                              fill={  checked ? 'text-action dark:text-action' : 'secondary dark:text-secondary-dark' }
                              color={ checked ? `text-action dark:text-action` : 'secondary dark:text-secondary-dark' }
                              name={ icon }
                           />
                        </div>
                     ) }
                     {
                        label && (
                           <span
                              className={ cx({
                                 [`font-medium leading-5 text-sm`]: true,
                                 'font-semibold text-action dark:text-action': newstyle && checked,
                                 'text-secondary dark:text-major-dark': !checked,
                                 '!leading-6 whitespace-nowrap': newstyle,
                              }) }
                           >
                              { label }
                           </span>
                        )
                     }
                  </>
               )
            }
            {
               isLoading && !checked && (
                  <Loader
                     size={ newstyle ? '6' : '10' }
                  />
               )
            }
         </div>
      </div>
   );
};

SwitchItem.defaultProps = {
   iconSize: 'base',
   newstyle: false,
};

SwitchItem.propTypes = {
   label: PropTypes.string,
   checked: PropTypes.bool,
   isLoading: PropTypes.bool,
   icon: PropTypes.string,
   onClick: PropTypes.func.isRequired,
   iconSize: PropTypes.string,
   newstyle: PropTypes.bool,
};

export default memo(SwitchItem);
